var _GroupedChatServiceInit_instances, _GroupedChatServiceInit_hashGenerator, _GroupedChatServiceInit_groupedChats, _GroupedChatServiceInit_appendChat, _GroupedChatServiceInit_getMessageLength, _GroupedChatServiceInit_removePrevChat;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
import { HashGenerator } from '../../util/hash/HashGenerator';
class GroupedChatServiceInit {
    constructor() {
        _GroupedChatServiceInit_instances.add(this);
        _GroupedChatServiceInit_hashGenerator.set(this, new HashGenerator());
        _GroupedChatServiceInit_groupedChats.set(this, writable([]));
    }
    get groupedChats() {
        return __classPrivateFieldGet(this, _GroupedChatServiceInit_groupedChats, "f");
    }
    updateChats(chats) {
        let chatGroups = [];
        chats.forEach((chat) => {
            chatGroups = __classPrivateFieldGet(this, _GroupedChatServiceInit_instances, "m", _GroupedChatServiceInit_appendChat).call(this, chatGroups, chat);
        });
        __classPrivateFieldGet(this, _GroupedChatServiceInit_groupedChats, "f").set(chatGroups);
    }
    addChat(chat) {
        __classPrivateFieldGet(this, _GroupedChatServiceInit_groupedChats, "f").update((it) => {
            return __classPrivateFieldGet(this, _GroupedChatServiceInit_instances, "m", _GroupedChatServiceInit_appendChat).call(this, it, chat);
        });
    }
    updateReactions(chatHash, reactions) {
        __classPrivateFieldGet(this, _GroupedChatServiceInit_groupedChats, "f").update((it) => {
            it.forEach((groupedChat) => {
                const messages = groupedChat.messages;
                const found = messages.find((m) => m.hash === chatHash);
                if (found) {
                    found.reactions = reactions;
                }
            });
            return [...it];
        });
    }
    updateLink(chatHash, title, thumbnail) {
        __classPrivateFieldGet(this, _GroupedChatServiceInit_groupedChats, "f").update((it) => {
            it.forEach((group) => {
                const found = group.messages.find((m) => m.hash === chatHash);
                if (found) {
                    const json = JSON.parse(found.body);
                    json.info.title = title;
                    json.info.thumbnail = thumbnail;
                    found.body = JSON.stringify(json);
                }
            });
            return [...it];
        });
    }
}
_GroupedChatServiceInit_hashGenerator = new WeakMap(), _GroupedChatServiceInit_groupedChats = new WeakMap(), _GroupedChatServiceInit_instances = new WeakSet(), _GroupedChatServiceInit_appendChat = function _GroupedChatServiceInit_appendChat(prev, chat) {
    if (__classPrivateFieldGet(this, _GroupedChatServiceInit_instances, "m", _GroupedChatServiceInit_getMessageLength).call(this, prev) > 50) {
        prev = __classPrivateFieldGet(this, _GroupedChatServiceInit_instances, "m", _GroupedChatServiceInit_removePrevChat).call(this, prev);
    }
    const lastChatGroup = prev[prev.length - 1];
    let last;
    if (lastChatGroup &&
        lastChatGroup.icon === chat.sender.icon &&
        lastChatGroup.nickname === chat.sender.nickname &&
        lastChatGroup.senderType === chat.sender.type) {
        last = lastChatGroup;
    }
    else {
        last = {
            hash: __classPrivateFieldGet(this, _GroupedChatServiceInit_hashGenerator, "f").generate('chat'),
            icon: chat.sender.icon,
            nickname: chat.sender.nickname,
            senderType: chat.sender.type,
            messages: [],
        };
        prev.push(last);
    }
    last.messages.push(chat.message);
    return [...prev];
}, _GroupedChatServiceInit_getMessageLength = function _GroupedChatServiceInit_getMessageLength(groups) {
    return groups.length === 0
        ? 0
        : groups.map((e) => e.messages.length).reduce((a, b) => a + b);
}, _GroupedChatServiceInit_removePrevChat = function _GroupedChatServiceInit_removePrevChat(prev) {
    const first = prev[0];
    const messages = first.messages;
    messages.shift();
    if (messages.length === 0) {
        prev.shift();
    }
    return [...prev];
};
export const GroupedChatService = new GroupedChatServiceInit();
